import { AuthContext } from "../providers/AuthProvider";
import { useContext } from "react";

export default function useAuthContext() {
  return useContext(AuthContext);
}
